import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import http from 'http'
import https from 'https'
// const VueAnalytics = require('vue-analytics')
import { debounce } from 'lodash'
import uuid from 'uuidv4'
import VueAnalytics from 'vue-analytics';

axios.defaults.timemout = 30 * 60 * 1000
axios.defaults.httpAgent = new http.Agent({ keepAlive: true })
axios.defaults.httpsAgent = new https.Agent({ keepAlive: true })

Vue.config.productionTip = false

Vue.prototype.$http = axios

Vue.filter('formatBytes', function(bytes, decimal, units) {
    if (0 == bytes) return "0 Bytes";
    var b = 1024,
        d = decimal || 2,
        u = units || ["Bytes", "KB", "MB", "GB"],
        i = Math.floor(Math.log(bytes) / Math.log(b));
    return parseFloat((bytes / Math.pow(b, i)).toFixed(d)) + " " + u[i]
})

// Vue.filter('fourDecimalPlaces', function(item, decimal) {
//     var d = decimal || 4
//     if (!isNaN(item) && !Number.isInteger(item)) return parseFloat(item).toFixed(d)
//     return item
// })

Vue.directive('focus', {
    inserted: function(el, binding, vnode) {
        el.addEventListener('focusin', () => {
            if (!el.value) {
                vnode.context.warning.uuid = ''
            }
            vnode.context.msg = 'FETCH RESULT'
        });
        el.addEventListener('focusout', () => {
            if (!el.value) {
                vnode.context.msg = 'Choose file'
                vnode.context.UUID_msg = 'TRY A TASK ID'
                vnode.context.warning.uuid = ''
            }
        });
        el.addEventListener('input', debounce(() => {
            if (el.value) {
                vnode.context.msg = 'FETCH RESULT'
                vnode.context.UUID_msg = 'CLEAR TASK ID'
            }
            let id = '' + el.value
            uuid.is(id) && id.length === 36 ? vnode.context.warning.uuid = '' : vnode.context.warning.uuid = 'Your task id is invalid.'
        }, 200));
    }
})

Vue.directive('focus', {
    inserted: function(el, binding, vnode) {
        el.addEventListener('focusin', () => {
            if (!el.value) {
                vnode.context.warning.uuid = ''
            }
            vnode.context.msg = 'FETCH RESULT'
        });
        el.addEventListener('focusout', () => {
            if (!el.value) {
                vnode.context.msg = 'Choose file'
                vnode.context.UUID_msg = 'TRY A TASK ID'
                vnode.context.warning.uuid = ''
            }
        });
        el.addEventListener('input', debounce(() => {
            if (el.value) {
                vnode.context.msg = 'FETCH RESULT'
                vnode.context.UUID_msg = 'CLEAR TASK ID'
            }
            let id = '' + el.value
            uuid.is(id) && id.length === 36 ? vnode.context.warning.uuid = '' : vnode.context.warning.uuid = 'Your task id is invalid.'
        }, 200));
    }
})

Vue.directive('drag-drop', {
    inserted: function(el, binding, vnode) {
        el.addEventListener('dragenter', function() {
            this.classList.toggle("is-active")
        });
        el.addEventListener('dragleave', function() {
            this.classList.toggle("is-active")
        });
        el.addEventListener('drop', function() {
            this.classList.remove("is-active")
        })
    }
})

Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GA,
    router,
    checkDuplicatedScript: true,
    autoTracking: {
        exception: true
    }
})

// console.log(process.env.VUE_APP_GA)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')